// src/Components/ProductPage.js
import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ProductCard from "./ProductCard";
import ProductSpecifications from "./ProductSpecifications";
import Footer from "./Footer";
// Main product images
import ConcreteScrew from "../assets/ConcreteScrew.png";
import drywall1 from "../assets/drywall1.png";
import Selfdrilling from "../assets/Selfdrilling.png";
import Selftapping from "../assets/Selftapping.png";
import woodscrew from "../assets/WoodScrew/WS1.png";
import image6 from '../assets/item6.png';

import csk from "../assets/csk.png";
import cskslotted from "../assets/csk-slotted.png";
import philips from "../assets/philips.png";
import panphilips from "../assets/pan-philips.png";
import pan from "../assets/pan.png";

import SS from '../assets/ss.png'
import SDSFlat from "../assets/SDS-Flat.png";
import SDSHex from "../assets/SDS-Hex.png";
import SDSPan from "../assets/SDS-Pan.png";
import SDSWafer from "../assets/SDS-Wafer.png";

import allenkey from '../assets/allenkey.png'
import concrete1 from '../assets/Concrete/concrete1.png';
import concrete2 from '../assets/Concrete/CN1.png';

import concrete3 from '../assets/Concrete/CN2.png';

import drywall2 from '../assets/Drywall/drywall2.png';

import application from '../assets/Drywall/application.png'
import selfdrilling1 from '../assets/SelfDrilling/selfdrilling1.png';
import selfdrilling2 from '../assets/SelfDrilling/selfdrilling2.png';
import selftapping1 from '../assets/SelfTapping/selftapping1.png';
import woodscrew1 from '../assets/WoodScrew/WS1.png';
import woodscrew2 from '../assets/WoodScrew/WS2.png';
import woodscrew3 from '../assets/WoodScrew/WS3.png';

import woodscrew5 from '../assets/WoodScrew/woodscrew5.png';

import JCB1 from '../assets/JCB1.png';
import JCB2 from '../assets/JCB2.png';

import allenscrew from '../assets/allen2.png'
import allen2 from '../assets/allen.png'
import "./ProductPage.css";
import BackToHomeButton from "./BackToHomeButton";
import { type } from "@testing-library/user-event/dist/type";
import { image } from "framer-motion/client";
const products = [
  
  
  {
    name: "Drywall Screw",
    
    image: drywall1,
    description: "Specialized screw with Trumpet (Bugle), Phillip head, Fine thread, Self-pierce that is designed for gypsum board fixing false ceiling, drywall partitions and attached plaster board to steel girders, however it is a versatile construction fastener with many uses. The diameter of drywall screw threads is larger than the grip diameter and it can be easily drive without pre drilling.",
    specifications: {
      Material: "Carbon Steel",
      Drive_Style: "Phillips",
      Head_Style: "Bugle",
      Coating: ["Black Phosphated","Grey Phosphated", "Zinc Coated", "Nickel Coated","Antique Coated","Aluminium Flake Coated"],
      Application: ["Drywall Installation", "Ceiling & Partitioning", "Furniture Assembly", "DIY & Home Repairs"]
    },
    sizes: [
      { Size: "3.5 X", Lengths: ["13mm", "16mm", "19mm", "25mm", "32mm", "38mm", "50mm", "62mm", "75mm"] },
      { Size: "4.2 X", Lengths: ["13mm", "16mm", "19mm", "25mm", "32mm", "38mm", "50mm", "62mm", "75mm"] }
    ],
    additionalImages: [drywall2, application]
  },
  {
    name:"SDS Hex Washer",
    image: SDSHex,
    description:"Engineered for medium-duty applications, this fastener includes a washer with an EPDM rubber layer, ensuring a strong and dependable hold. Its self-tapping threads enable swift penetration during installation, streamlining operations for greater efficiency.",
    specifications:{
      Head: "Hex",
      Drive_Style: "Hex Drive",
      Finished:"Zinc Plated"
    },
    sizes:[
      {Size:"10x",Lengths:["19","25"]},
      {Size:"12x",Lengths: ["25","35","45","55","65","75","100"]}

    ]


  },
  {
    name:"SDS CSK Philips",
    image: SDSFlat,
    description:"Sheet metal screws are originally designed for metal-to-metal, metal-to-wood, and furniture works but can be used for a variety of other applications as well. They can be used with plastics, rubber, or plywood. The screws are classified based on the head of the screw and the screw drive type. The following are the head shapes available in our product range.",
    specifications:{
      Head:"Flat",
      Drive_Style:"Philips",
      Finished:"Zinc Plated"
    },
    sizes:[
      { Size: "6 x", Lengths: [  "13","16","19","25","32","38"] },
      { Size: "8 x", Lengths: ["13","16","19","25","32","38"] }
    ]
  },
  
  {
    name:"SDS Pan Philips",
    image: SDSPan,
    description:"Featuring gently rounded sides like a shallow pan, these screws sit flush with the material upon installation, ensuring a smooth and polished look. The Phillips drive allows for effortless fastening, while self-tapping threads provide strong and reliable engagement.",
    specifications:{
      Head:"Pan",
      Drive_Style:"Philips",
      Finished:"Zinc Plated"
    },
    sizes:[
      {Size: "6 x", Lengths: [  "13","16","19","25","32","38"] },
      {Size: "8 x", Lengths: ["13","16","19","25","32","38"] }

    ]
  },
  {
    name:"SDS Wafer Head",
    image: SDSWafer,
    description:"The truss head has a circular shape with a wider diameter and a low profile, offering an extended bearing surface for even load distribution. Featuring a Phillips drive and self-tapping threads, it enables quick and effortless installation, enhancing construction efficiency.",
    specifications:{
      Head:"Wafer",
      Drive_Style:"Philips",
      Finished:"Zinc Plated"

    },
    sizes:[
      { Size: "8 x", Lengths: ["13","16","19","25","32","38","50"] }
    ]
  },
  {
    name:"CSK Self-Tapping Screw",
    image: csk,
    description:"A sheet metal screw is a specialized fastener designed to securely attach metal sheets to other materials, such as metal, plastic, or wood. These screws feature sharp, self-tapping threads that allow them to cut through and grip sheet metal without requiring pre-drilling in many cases. They are available in different head styles (flat, round, hex, and pan) and drive types (Phillips, slotted, Torx) for various applications.",
    specifications: {
      Head:"Flat",
      Drive_Style:"Slotted",
      Finished:"Zinc Plated"

    },
    sizes:[
      { Size: ["4 x"], Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: ["5 x"], Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: ["6 x"], Lengths: ["6.5", "9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size:[ "8 x"], Lengths: ["9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size: ["10 x"], Lengths: ["19","25","32","38","50","60"] },
      { Size: ["12x"], Lengths: ["19","25"] },
    ]

  },
  {
    name:"CSK Raised Self-Tapping Screw",
    image: cskslotted,
    description:"A sheet metal screw is a specialized fastener designed to securely attach metal sheets to other materials, such as metal, plastic, or wood. These screws feature sharp, self-tapping threads that allow them to cut through and grip sheet metal without requiring pre-drilling in many cases. They are available in different head styles (flat, round, hex, and pan) and drive types (Phillips, slotted, Torx) for various applications",
    specifications: {
      Head:"Raised",
      Drive_Style:"Slotted",
      Finished:"Zinc Plated"
    },
    sizes:[
      { Size: "4 x", Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: "5 x", Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: "6 x", Lengths: ["6.5", "9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size: "8 x", Lengths: ["9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size: "10 x", Lengths: ["19","25","32","38","50","60"] },
      { Size: "12x", Lengths: ["19","25"] },

    ]

  },
  {
    name:"CSK Philips Self-Tapping Screw",
    image: philips,
    description:"A sheet metal screw is a specialized fastener designed to securely attach metal sheets to other materials, such as metal, plastic, or wood. These screws feature sharp, self-tapping threads that allow them to cut through and grip sheet metal without requiring pre-drilling in many cases. They are available in different head styles (flat, round, hex, and pan) and drive types (Phillips, slotted, Torx) for various applications.",
    specifications: {
      Head:"Flat",
      Drive_Style:"Philips",
      Finished:"Zinc Plated"
    },
    sizes:[
      { Size: "4 x", Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: "5 x", Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: "6 x", Lengths: ["6.5", "9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size: "8 x", Lengths: ["9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size: "10 x", Lengths: ["19","25","32","38","50","60"] },
      { Size: "12x", Lengths: ["19","25"] },
    ]

  },
  {
    name:"Pan philips Self-Tapping Screw",
    image: panphilips,
    description:"A sheet metal screw is a specialized fastener designed to securely attach metal sheets to other materials, such as metal, plastic, or wood. These screws feature sharp, self-tapping threads that allow them to cut through and grip sheet metal without requiring pre-drilling in many cases. They are available in different head styles (flat, round, hex, and pan) and drive types (Phillips, slotted, Torx) for various applications.",
    specifications:{
      Head:"Pan",
      Drive_Style:"Philips",
      Finished:"Zinc Plated"

    },
    sizes:[
      { Size: "4 x", Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: "5 x", Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: "6 x", Lengths: ["6.5", "9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size: "8 x", Lengths: ["9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size: "10 x", Lengths: ["19","25","32","38","50","60"] },
      { Size: "12x", Lengths: ["19","25"] },
    ]
  },
  {
    name:"Pan-Self Tapping Screw",
    image: pan,
    description:"A sheet metal screw is a specialized fastener designed to securely attach metal sheets to other materials, such as metal, plastic, or wood. These screws feature sharp, self-tapping threads that allow them to cut through and grip sheet metal without requiring pre-drilling in many cases. They are available in different head styles (flat, round, hex, and pan) and drive types (Phillips, slotted, Torx) for various applications.",
    specifications:{
      Head:"Pan",
      Drive_Style:"Slotted",
      Finished:"Zinc Plated"

    },
    sizes:[
      { Size: "4 x", Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: "5 x", Lengths: ["6.5","9.5","13", "16", "19","25"] },
      { Size: "6 x", Lengths: ["6.5", "9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size: "8 x", Lengths: ["9.5",  "13","16","19","25","32","38","45","50","60"] },
      { Size: "10 x", Lengths: ["19","25","32","38","50","60"] },
      { Size: "12x", Lengths: ["19","25"] },
    ]
  },
  {
    name:"Allen Key Screw",
   
    image:allenscrew,
    description:"A ALLEN KEY (JCB ) Head Wood Screw is a specialized wood fastener featuring a low-profile, wide-diameter head for enhanced load distribution. It is designed to provide a secure and stable connection in wood-to-wood or wood-to-metal applications. The wide head prevents the screw from sinking too deeply, ensuring a flush and professional finish. These screws often feature deep, coarse threads for maximum grip and holding power in wooden materials.",
    specifications: {
      Type: "Wood",
      Application:["Furniture Assembly","Woodworking & Carpentry","Home Improvement & Renovation","Construction & Industrial Applications"]

    },
    sizes:[
      {Size:["6x"] , Lengths:["50","60"]}
    ],
    additionalImages:[allen2]
  },
  
  
  
  
  
  {
    name: "Wood Screw",

    image: woodscrew2,
    description: "A wood screw is a threaded fastener specifically designed for securing wood materials. It features a sharp, tapered point that allows for easy penetration into wood without requiring pre-drilling in most cases. The threads are deep and widely spaced to grip the wood securely, preventing loosening over time. Wood screws come in various head types (flat, round, oval) and drive styles (Phillips, slotted, Torx) to suit different applications.",
    specifications: {
      Type: "Wood",
     
      RawMaterial: "Brass or steel",
      Application: ["Carpentry & Woodworking", "Construction & Home Renovation", "Furniture Manufacturing & Assembly"," DIY & Home Repairs","Specialized & Industrial Applications"]
    },
    sizes: [
      { Size: "2 ", Lengths: ["10mm"] },
      { Size: "3", Lengths: ["10mm","12mm"] },
      {Size:"4", Lengths: ["12mm","15mm","20mm"]},
      {Size:"5", Lengths: ["12mm","15mm","20mm","25mm"]},
      {Size:"6", Lengths: ["12mm","15mm","20mm","25mm","30mm","35mm","40mm","45mm","50mm","60mm","75mm"]},
      {Size:"7", Lengths: ["12mm","15mm","20mm","25mm","30mm","35mm"]},
      {Size:"8", Lengths: ["12mm","15mm","20mm","25mm","30mm","35mm","40mm","45mm","50mm","60mm","75mm"]},
      {Size:"9", Lengths: ["20mm","25mm","30mm","35mm","40mm","45mm","50mm","60mm"]},
      {Size:"10", Lengths: ["20mm","25mm","30mm","35mm","40mm","45mm","50mm","60mm","75mm","85mm","100mm"]},
      {Size:"12",Lengths:["30mm","35mm","40mm","45mm","50mm","60mm","75mm","85mm","100mm"]},
      {Size:"14",Lengths:["30mm","35mm","100mm"]}
    ],
    additionalImages: [woodscrew1, woodscrew, woodscrew3, woodscrew5]
  },
  {
    name: "Joint Connector Bolt",
    
    image: image6,
    description: "A joint connector bolt (JCBC) is a specialized fastener designed to securely connect two or more components, typically used in furniture assembly and structural applications. It features a low-profile head and a threaded shaft, often paired with barrel nuts or cross dowels to create a strong and stable joint.",
    specifications: {
      
      RawMaterial: "carbon",
      Application: ["Furniture Assembly", "Woodworking & Carpentry", "Metal Fabrication","Architectural & Construction Frameworks", "Automotive & Machinery"]
    },
    sizes: [
      { Size: "M6x", Lengths: ["25mm", "30mm", "40mm", "50mm", "75mm"] },
      
    ],
    additionalImages: [JCB1, JCB2]
  },
  
  
  
  {
    name:"SS Screw",
    image:SS,
    description:"Stainless steel self-tapping screws are designed to cut their own threads as they are driven into various materials. Their corrosion resistance makes them ideal for both indoor and outdoor use. Below is a detailed breakdown of their applications across different industries.",
    specifications:{
      Drive_Style:"Philips",
      Head_Style:"Flat Head",
      Application:["Construction & Architecture","Automotive & Transportation","Electrical & Electronics","Plumbing & Piping Systems","Furniture, Appliances & Consumer Goods"],

    },
    
  },
  {
    name: "Concrete Nail",
    
    image: concrete3,
    description: "A concrete nail is a high-strength steel fastener specifically designed to penetrate and anchor materials into hard surfaces like concrete, masonry, and bricks. Made from hardened carbon steel, these nails are heat-treated to resist bending or breaking upon impact. They typically have a fluted, grooved, or smooth shank for improved holding power and durability.",
    specifications: {
      Material: "Steel",
     
      Head_Style: "Flat",
      Coating: "Zinc",
      Application:["Concrete & Masonry Fastening", "Wood-to-Concrete Fastening", "Metal-to-Concrete Fastening", "DIY & Home Repairs"]
    },
    sizes: [
      {Size:["-"] , Lengths: ["1`","1.5`","2`","2.5","3","4","5"]}
    ],
    additionalImages: [concrete1, concrete2, ConcreteScrew]
  }
  


  
  
];
/*

*/


const ProductPage = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [filterType, setFilterType] = useState("All");


  const handleProductClick = (product) => {
    setSelectedProduct(product);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCloseSpecifications = () => {
    setSelectedProduct(null);
  };

  const filteredProducts = filterType === "All" 
    ? products 
    : products.filter(product => product.type.toLowerCase() === filterType.toLowerCase());

  useEffect(() => {
    window.scrollTo({ top: 700, behavior: 'smooth' });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-gradient-to-b from-green-50 to-green-100"
    >
      <div className="container justify-center items-center mx-auto px-4 py-8">
        <div className="mb-6">
          <BackToHomeButton />
        </div>
        <h1 className="text-4xl font-bold text-center text-green-800 mb-8">Our Products</h1>
        
        {/* Filter buttons */}
        

        {/* Product grid */}
        <motion.div 
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          layout
        >
          <AnimatePresence>
            {filteredProducts.map((product, index) => (
              <motion.div
                key={product.name}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ delay: index * 0.1 }}
                layout
              >
                <ProductCard product={product} onClick={() => handleProductClick(product)} />
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      {/* Product Specifications Modal */}
      <AnimatePresence>
        {selectedProduct && (
          <ProductSpecifications
            product={selectedProduct}
            isOpen={!!selectedProduct}
            onClose={handleCloseSpecifications}
          />
        )}
      </AnimatePresence>

      
    </motion.div>
  );
};

export default ProductPage;

